module.exports = __webpack_public_path__ + "static/living-creations-preview-5168309c4f1b6702817b734d6c587ce2.jpg";